const NAV_SELECTOR = '[data-nav-primary]';
const NAV_LIST_SELECTOR = '[data-nav-items]';

const TOGGLER_CLASS = 'primary-nav-toggler';
const ACTIVE_NAVIGATION_CLASS = 'nav-visible';
const ACTIVE_DROPDOWN_CLASS = 'dropdown-visible';

class MainNavigation {
  constructor() {
    let wrapper = document.querySelector(NAV_SELECTOR);
    if (!wrapper) {
      return;
    }

    this.wrapper = wrapper;
    this.dropdownTriggers = this.findDropdownTriggers();
    this.toggler = this.createToggler();

    this.wrapper.insertAdjacentElement('beforeBegin', this.toggler);

    this.bindEvents();
  }

  findDropdownTriggers() {
    let triggers = Array.prototype.filter.call(
      this.wrapper.querySelectorAll(`${NAV_LIST_SELECTOR} > li > a`),
      node => {
        let boundList = node.parentNode.querySelector('ul');
        node.boundList = boundList;
        return !!boundList;
      }
    );

    return triggers;
  }

  createToggler() {
    let toggler = document.createElement('button');
    toggler.setAttribute('type', 'button');
    toggler.innerHTML = 'Menu';
    toggler.classList.add(TOGGLER_CLASS);
    return toggler;
  }

  enableMenu() {
    this.wrapper.classList.add(ACTIVE_NAVIGATION_CLASS);
  }

  disableMenu() {
    this.wrapper.classList.remove(ACTIVE_NAVIGATION_CLASS);
  }

  toggleMenu() {
    this.wrapper.classList.toggle(ACTIVE_NAVIGATION_CLASS);
  }

  enableDropdown(trigger) {
    trigger.boundList.classList.add(ACTIVE_DROPDOWN_CLASS);
  }

  disableDropdown(trigger) {
    trigger.boundList.classList.remove(ACTIVE_DROPDOWN_CLASS);
  }

  toggleDropdown(trigger) {
    trigger.boundList.classList.toggle(ACTIVE_DROPDOWN_CLASS);
  }

  bindEvents() {
    this.toggler.addEventListener('click', e => {
      e.preventDefault();
      this.toggleMenu();
    });

    Array.prototype.forEach.call(this.dropdownTriggers, trigger => {
      let parent = trigger.parentNode;
      parent.addEventListener(
        'focusout',
        e => {
          if (parent.contains(e.relatedTarget) === false) {
            this.disableDropdown(trigger);
          }
        },
        true
      );
    });

    document.querySelector('body').addEventListener('click', e => {
      Array.prototype.forEach.call(this.dropdownTriggers, trigger => {
        if (trigger.parentNode.contains(e.target) === false) {
          this.disableDropdown(trigger);
        } else if (trigger === e.target) {
          e.preventDefault();
          this.toggleDropdown(trigger);
        }
      });
    });
  }
}

export default MainNavigation;



// WEBPACK FOOTER //
// ./src/javascripts/MainNavigation.js